import React from 'react'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const FavoriteButton = ({onClick, color})=> {

  return(
    <button
      type="button"
      className="favorite-button"
      style={{backgroundColor: color, border: 'none', padding: 0, cursor: 'pointer'}}
      onClick={onClick}
      aria-label="Add to favorites"
    >
      <FavoriteBorderIcon style={{fontSize: 24}}/>
    </button>
  )
}

export default FavoriteButton;
